import type { CriterionLocaleBundle } from '../localize'

/** Unofficial translations from docs/kata — English scoring text remains authoritative. */
export const kodokanGoshinJutsuCriteriaI18n: CriterionLocaleBundle = {
  ja: {
    'goshin-gen-weapons-place': {
      text: '武器を正しく置き、取り上げる方法。',
    },
    'goshin-gen-weapon-use': {
      text: '各技での武器の扱い。',
    },
    'goshin-gen-direction': {
      text: '技の方向。',
    },
    'goshin-gen-armlock-look': {
      text: '腕の関節技を施す際、取は前方を見る。',
    },
    'goshin-gen-kiai': {
      text: '気合（kiai）。',
      hint: '不要な場合に発する：小（Small）。必要な場合に発しない：中（Medium）',
    },
    'goshin-gen-submit': {
      text: '二回たたいて参ったの合図をする。',
    },
    'goshin-gen-weapons-mat': {
      text: '形の開始時に武器を正しく畳に置き、終了時に取り上げる方法',
    },
    'goshin-ryote-dori-1': {
      text: '受は左足を踏み出して取の両手首を握り、右膝で取の股間を攻撃し、気合を発する。',
    },
    'goshin-ryote-dori-2': {
      text: '取は左足を左後方へ踏み出し、右手首の握りを外す。手刀（Te-gatana）で受のこめかみに当身を加え、気合を発する。小手捻（Kote-hineri）を施し、立ったまま腕を制し、前方を見る。',
    },
    'goshin-ryote-dori-3': {
      text: '受は自分の左脚を二回たたいて参ったの合図をする。過度に前屈しない。',
    },
    'goshin-hidari-eri-dori-1': {
      text: '受は右手で取の左襟を握り、取を後方へ押し倒そうとする。',
    },
    'goshin-hidari-eri-dori-2': {
      text: '取は襟を開き、目潰し（Me-tsubushi）、小手捻を施し、受を倒して腕挫手固（Ude-hishigi-te-gatame）を施す。',
    },
    'goshin-hidari-eri-dori-3': {
      text: '受はうつ伏せになり、畳を二回たたく。',
    },
    'goshin-migi-eri-dori-1': {
      text: '受は右手で取の右襟を握り、左足を引いて取を強く下へ引く。',
    },
    'goshin-migi-eri-dori-2': {
      text: '取は右足を踏み出し、右拳で受の顎を突き上げ、気合を発する。',
    },
    'goshin-migi-eri-dori-3': {
      text: '取は小手返（Kote-gaeshi）を施し、受を前方へ投げる。',
    },
    'goshin-kata-ude-dori-1': {
      text: '開始位置：受は取の右後隅に立つ。後ろから取の右肘に腕の関節技を施し、前進する。',
    },
    'goshin-kata-ude-dori-2': {
      text: '三歩目で取は受の方へ半回転し、受の左膝の内側を蹴り、気合を発する。',
    },
    'goshin-kata-ude-dori-3': {
      text: '取は立ち姿勢で腕挫腋固（Ude-hishigi-waki-gatame）を施し、前方を見る。受は二回たたいて参ったの合図をする。',
    },
    'goshin-ushiro-eri-dori-1': {
      text: '受は後ろから取の後襟を握り、取を後方へ引き倒そうとする。',
    },
    'goshin-ushiro-eri-dori-2': {
      text: '取は体を回し、顔を守り、水月を突き、気合を発し、腕挫腕固（Ude-hishigi-ude-gatame）を施す。',
    },
    'goshin-ushiro-eri-dori-3': {
      text: '受は自分の左脚を二回たたいて参ったの合図をする。過度に前屈しない。',
    },
    'goshin-ushiro-jime-1': {
      text: '受は後ろから立ち姿勢で裸絞（Hadaka-jime）を試みる。',
    },
    'goshin-ushiro-jime-2': {
      text: '取は防ぎ、体をひねり、受を畳へ引き倒し、腕挫手固で制する。',
    },
    'goshin-ushiro-jime-3': {
      text: '受はうつ伏せになり、畳を二回たたく。',
    },
    'goshin-kakae-dori-1': {
      text: '受は取の両腕の上から腰を後ろから抱える。',
    },
    'goshin-kakae-dori-2': {
      text: '取は受の足の甲を踏んで気合を発し、抱えを解き、腕の関節技を施して受を斜め前方へ投げる。',
    },
    'goshin-kakae-dori-3': {
      text: '受は立ち上がらない。取は自然体（shizen-tai）になる。',
    },
    'goshin-naname-uchi-1': {
      text: '受は右拳で取の左こめかみを打とうとし、気合を発する。',
    },
    'goshin-naname-uchi-2': {
      text: '取はかわし／払い、顎を突き上げて気合を発し、矢筈（Yahazu）を喉に当てて大外落（Osoto-otoshi）で投げる。',
    },
    'goshin-ago-tsuki-1': {
      text: '受は右拳で取の顎を突き上げようとし、気合を発する。',
    },
    'goshin-ago-tsuki-2': {
      text: '取は打撃をそらし、腕の関節技を施し、受を斜め前方へ投げる。受は立ち上がらない。',
    },
    'goshin-ganmen-tsuki-1': {
      text: '受は左構えになり、取の顔面を突こうとし、気合を発する。',
    },
    'goshin-ganmen-tsuki-2': {
      text: '取は脇腹を突いて気合を発し、後ろから裸絞を施す。受は足で二回たたいて参ったの合図をする。',
    },
    'goshin-mae-geri-1': {
      text: '受は右足の足裏で取の股間を前蹴で攻撃し、気合を発する。',
    },
    'goshin-mae-geri-2': {
      text: '取は攻撃をかわし、足／足首を制し、受を仰向けに倒す。',
    },
    'goshin-yoko-geri-1': {
      text: '受は取の側方を横蹴で攻撃しようとし、気合を発する。',
    },
    'goshin-yoko-geri-2': {
      text: '取は蹴りを払いのけ、受の後ろへ進み、受を引いて仰向けに倒す。',
    },
    'goshin-tsukkake-1': {
      text: '受は短刀を抜き（刃を上に向け）、半歩の間合いで準備する。',
    },
    'goshin-tsukkake-2': {
      text: '取は受の左側へ進み、目潰しを加えて気合を発し、腕挫手固を施す。受は短刀を持ったまま二回たたく。',
    },
    'goshin-tsukkake-3': {
      text: '武器の返し方：該当する場合、短刀を正しく返す。',
    },
    'goshin-choku-tsuki-1': {
      text: '受は前進し、取の腹を刺そうとし、気合を発する。',
    },
    'goshin-choku-tsuki-2': {
      text: '取は突きを払い、顎を突き上げて気合を発し、立ち姿勢で腕挫腋固を施し、前方を見る。受は二回たたいて参ったの合図をする。',
    },
    'goshin-naname-tsuki-1': {
      text: '受は短刀を逆手で抜き、首の左側を刺そうとし、気合を発する。',
    },
    'goshin-naname-tsuki-2': {
      text: '取はかわし、小手返で投げ、手固（te-gatame）で制し、刃の側を握らずに短刀を取り上げる。受は二回たたく。',
    },
    'goshin-furi-age-1': {
      text: '受は杖を頭上に振り上げて攻撃しようとする。',
    },
    'goshin-furi-age-2': {
      text: '取は止め、顎を押し上げて気合を発し、大外刈（O-soto-gari）で投げ、受が畳に倒れるまで襟を保持する。',
    },
    'goshin-furi-oroshi-1': {
      text: '受は取の頭の左側、左横面を斜めに打とうとし、気合を発する。',
    },
    'goshin-furi-oroshi-2': {
      text: '取はかわし、当身を加えて気合を発し、杖を取り、受を後方へ押し倒す。',
    },
    'goshin-morote-tsuki-1': {
      text: '受は杖の先で取の水月を突き、気合を発する。',
    },
    'goshin-morote-tsuki-2': {
      text: '取は体捌き（Tai-sabaki）でそらし、杖／腕の関節技で制し、受を投げて杖の先を受に向ける。受は立ち上がらない。',
    },
    'goshin-shomen-zuke-1': {
      text: '受は「手を上げろ！」と命令し、銃口を取の腹に押し当てる。',
    },
    'goshin-shomen-zuke-2': {
      text: '受が下を見たとき、取は銃口をかわし、銃身／手首を制し、腰の動きだけで拳銃を取り上げる。',
    },
    'goshin-koshi-gamae-1': {
      text: '受は「手を上げろ！」と命令した後、腰で拳銃を持って取の腹に向ける。',
    },
    'goshin-koshi-gamae-2': {
      text: '取は腰をひねり、両手で拳銃を取り上げ、握りの底で受の顔を打ち、気合を発する。',
    },
    'goshin-haimen-zuke-1': {
      text: '受は後ろから「手を上げろ！」と命令した後、銃口を取の背の中央に押し当てる。',
    },
    'goshin-haimen-zuke-2': {
      text: '取は回ってかわし、前腕／拳銃を制し、受を投げて拳銃を取り上げる。',
    },
  },
  'zh-Hant': {
    'goshin-gen-weapons-place': {
      text: '正確放置及收取武器的方式。',
    },
    'goshin-gen-weapon-use': {
      text: '各項技術中的武器使用。',
    },
    'goshin-gen-direction': {
      text: '技術方向。',
    },
    'goshin-gen-armlock-look': {
      text: '取施手臂關節技時看向前方。',
    },
    'goshin-gen-kiai': {
      text: '氣合（kiai）。',
      hint: '不必要時發出：輕微（Small）；應有而未發出：中等（Medium）',
    },
    'goshin-gen-submit': {
      text: '認輸時拍擊兩次。',
    },
    'goshin-gen-weapons-mat': {
      text: '形開始時正確放置武器，以及結束時收取武器的方式',
    },
    'goshin-ryote-dori-1': {
      text: '受左腳前進，握取的雙手腕，以右膝攻擊取的腹股溝，發出氣合。',
    },
    'goshin-ryote-dori-2': {
      text: '取左腳向左後方踏出，解除右手腕的握持，以手刀（Te-gatana）擊受的太陽穴作當身，發出氣合；施小手捻（Kote-hineri），以站姿控制手臂並看向前方。',
    },
    'goshin-ryote-dori-3': {
      text: '受拍自己的左腿兩次表示認輸，不應過度彎腰。',
    },
    'goshin-hidari-eri-dori-1': {
      text: '受以右手握取的左襟，嘗試將取向後推倒。',
    },
    'goshin-hidari-eri-dori-2': {
      text: '取打開衣襟，施目潰（Me-tsubushi）、小手捻，將受帶倒並施腕挫手固（Ude-hishigi-te-gatame）。',
    },
    'goshin-hidari-eri-dori-3': {
      text: '受俯臥，拍榻榻米兩次。',
    },
    'goshin-migi-eri-dori-1': {
      text: '受以右手握取的右襟，左腳後退，用力將取向下拉。',
    },
    'goshin-migi-eri-dori-2': {
      text: '取右腳前進，以右拳上勾拳打受的下巴，發出氣合。',
    },
    'goshin-migi-eri-dori-3': {
      text: '取施小手返（Kote-gaeshi），將受向前摔出。',
    },
    'goshin-kata-ude-dori-1': {
      text: '起始位置：受在取的右後隅；從後方對取的右肘施手臂關節技並前進。',
    },
    'goshin-kata-ude-dori-2': {
      text: '第三步時，取向受轉半身，踢受左膝內側，發出氣合。',
    },
    'goshin-kata-ude-dori-3': {
      text: '取以站姿施腕挫腋固（Ude-hishigi-waki-gatame），看向前方；受拍擊兩次表示認輸。',
    },
    'goshin-ushiro-eri-dori-1': {
      text: '受從後握取的後領，嘗試將取向後拉倒。',
    },
    'goshin-ushiro-eri-dori-2': {
      text: '取轉身護臉，打心窩發出氣合，再施腕挫腕固（Ude-hishigi-ude-gatame）。',
    },
    'goshin-ushiro-eri-dori-3': {
      text: '受拍自己的左腿兩次表示認輸，不應過度彎腰。',
    },
    'goshin-ushiro-jime-1': {
      text: '受從後方嘗試以站姿施裸絞（Hadaka-jime）。',
    },
    'goshin-ushiro-jime-2': {
      text: '取防守、扭轉，將受拉倒地上，以腕挫手固控制。',
    },
    'goshin-ushiro-jime-3': {
      text: '受俯臥，拍榻榻米兩次。',
    },
    'goshin-kakae-dori-1': {
      text: '受從後方連同取的雙臂一起環抱其腰部。',
    },
    'goshin-kakae-dori-2': {
      text: '取踏受的腳背發出氣合，解除環抱，施手臂關節技並將受斜向前摔出。',
    },
    'goshin-kakae-dori-3': {
      text: '受不站起。取採自然體（shizen-tai）。',
    },
    'goshin-naname-uchi-1': {
      text: '受以右拳攻擊取的左太陽穴，發出氣合。',
    },
    'goshin-naname-uchi-2': {
      text: '取閃避／撥開，上勾拳打下巴發出氣合，再以矢筈（Yahazu）置於喉部，以大外落（Osoto-otoshi）摔出。',
    },
    'goshin-ago-tsuki-1': {
      text: '受以右拳上勾拳攻擊取的下巴，發出氣合。',
    },
    'goshin-ago-tsuki-2': {
      text: '取撥開拳擊，施關節技，將受斜向前摔出。受不站起。',
    },
    'goshin-ganmen-tsuki-1': {
      text: '受採左勢，攻擊取的臉部，發出氣合。',
    },
    'goshin-ganmen-tsuki-2': {
      text: '取打肋骨發出氣合，從後方施裸絞；受以腳拍擊兩次表示認輸。',
    },
    'goshin-mae-geri-1': {
      text: '受以右腳掌作前蹴攻擊取的腹股溝，發出氣合。',
    },
    'goshin-mae-geri-2': {
      text: '取避開攻擊，控制腳／腳踝，將受向後摔倒。',
    },
    'goshin-yoko-geri-1': {
      text: '受嘗試以橫蹴攻擊取的側方，發出氣合。',
    },
    'goshin-yoko-geri-2': {
      text: '取掃開踢擊，踏至受的後方，將受拉倒使其仰臥。',
    },
    'goshin-tsukkake-1': {
      text: '受拔出短刀（刃朝上），在相距半步處準備。',
    },
    'goshin-tsukkake-2': {
      text: '取移至受的左側，施目潰發出氣合，再施腕挫手固；受持著短刀拍擊兩次。',
    },
    'goshin-tsukkake-3': {
      text: '武器交還：適用時正確交還短刀。',
    },
    'goshin-choku-tsuki-1': {
      text: '受前進，嘗試刺取的腹部，發出氣合。',
    },
    'goshin-choku-tsuki-2': {
      text: '取撥開突刺，上勾拳發出氣合，以站姿施腕挫腋固並目視前方；受拍擊兩次表示認輸。',
    },
    'goshin-naname-tsuki-1': {
      text: '受以反手握法持短刀，嘗試刺頸部左側，發出氣合。',
    },
    'goshin-naname-tsuki-2': {
      text: '取閃避，以小手返摔出，以手固（te-gatame）控制，奪取短刀但不握刀刃側；受拍擊兩次。',
    },
    'goshin-furi-age-1': {
      text: '受將杖舉至頭上，嘗試攻擊。',
    },
    'goshin-furi-age-2': {
      text: '取阻擋，向上推下巴發出氣合，以大外刈（O-soto-gari）摔出，持續握襟直至受倒地。',
    },
    'goshin-furi-oroshi-1': {
      text: '受斜向攻擊取頭部的左側（左橫面），發出氣合。',
    },
    'goshin-furi-oroshi-2': {
      text: '取避開，施當身發出氣合，奪杖並將受向後推倒。',
    },
    'goshin-morote-tsuki-1': {
      text: '受以杖端擊取的心窩，發出氣合。',
    },
    'goshin-morote-tsuki-2': {
      text: '取以體捌（Tai-sabaki）掃撥，控制杖／施關節技，將受摔出並使杖端指向受。受不站起。',
    },
    'goshin-shomen-zuke-1': {
      text: '受命令「舉起手來」，將槍口抵住取的腹部。',
    },
    'goshin-shomen-zuke-2': {
      text: '受低頭時，取避開槍口，控制槍管／手腕，只運用髖部動作奪取手槍。',
    },
    'goshin-koshi-gamae-1': {
      text: '受命令「舉起手來」後，於髖部持槍指向取的腹部。',
    },
    'goshin-koshi-gamae-2': {
      text: '取扭髖，以雙手奪槍，再用握把底部擊受的臉，發出氣合。',
    },
    'goshin-haimen-zuke-1': {
      text: '受從後方命令「舉起手來」後，將槍口抵住取的背部中央。',
    },
    'goshin-haimen-zuke-2': {
      text: '取轉身避開，控制前臂／手槍，將受摔倒並奪槍。',
    },
  },
}
